import { ref } from 'vue';

const activeTooltip = ref<string | null>(null);

export function useTooltipManager() {
  const setActiveTooltip = (id: string | null) => {
    if (activeTooltip.value !== id) {
      activeTooltip.value = id;
    }
  };
  const resetTooltip = () => {
    activeTooltip.value = null;
  };

  return {
    activeTooltip,
    setActiveTooltip,
    resetTooltip,
  };
}
